export default (theme) => ({
    root: {
        padding: 0,
    },
    header: {
        marginTop: 20,
        marginBottom: 10,
    },
    label: {
        color: theme.colors.primary.black,
        textTransform: 'uppercase',
    },
});
